import styled from 'styled-components';
// width: ${({ isSidebarOpen }) =>
// isSidebarOpen ? "calc(100vw - 312px)" : "calc(100vw - 80px)"};
export const Background = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #00000033;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease-in-out all;
  z-index: 9999999 !important;
`;

export const Body = styled.div`
  min-width: 344px;
  width: auto;
  max-width: 80%;
  background-color: light-dark(#fff, var(--mantine-color-dark-6));

  padding: 16px;

  border-radius: 4px;
  background: light-dark(#fff, var(--mantine-color-dark-6));

  /* sm */
  box-shadow:
    0px 7px 7px -5px rgba(0, 0, 0, 0.04),
    0px 10px 15px -5px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05);
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  .toggler {
    font-size: 20px;
    color: light-dark(#5e5e5e, var(--mantine-color-dark-2));
    cursor: pointer;
  }
`;

export const Title = styled.h1`
  color: light-dark(#000, var(--mantine-color-text));
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
`;
